export default {
      id: "oval-usage",
      viewBox: "0 0 21 30",
      url: __webpack_public_path__ + "icons.svg#oval",
      toString: function () {
        return this.url;
      }
    }